import { complement, isEmpty, isNil, pickBy } from 'ramda';
import { stringify } from 'qs';
import { EOfferType, ISelectRealtorFormState } from '@cian/valuation-main-filters-widget';

import { ECode as EStepCode } from '../../../repositories/lead-realtor-form/entities/schema/StepSchema';

const objectToSkipStepMap: Record<EOfferType, EStepCode[]> = {
  [EOfferType.Flat]: [EStepCode.ObjectTypeFlat],
  [EOfferType.Suburban]: [EStepCode.ObjectTypeSuburban, EStepCode.ObjectTypeSuburbanWithLand],
  [EOfferType.Commercial]: [EStepCode.ObjectTypeCommercial, EStepCode.ObjectTypeCommercialWithBusiness],
};

/**
 * Утилита для составления qs строки по фильтрам, которые накликал юзер
 * qs строка состоит из ключей значений, которые диктуются риелторской формой (для этого взята енамка из формы)
 * */
export const prepareRealtorFormQs = (state?: Partial<ISelectRealtorFormState>): string => {
  if (!state || isEmpty(pickBy(complement(isNil), state))) {
    return '';
  }

  const preparedState = {
    form_dealTypeEx: state.dealType,
    form_offerType: state.offerType,
    form_objectType: state.objectType,
    skipSteps: [
      state.dealType && EStepCode.DealTypeEx,
      state.offerType && EStepCode.OfferType,
      state.objectType && state.offerType && objectToSkipStepMap[state.offerType],
    ]
      .flat()
      .filter(Boolean),
  };

  return stringify(preparedState, { skipNulls: true, addQueryPrefix: true, arrayFormat: 'brackets' });
};
